import { ConfirmPopup, Text } from '~/commonComponents';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';
import { Colors } from '~/themes/colors';

const SuccessIconComponent = () => <AnimatedCheckCircle />;

interface IRejectCandidateSuccessPopupProps {
  professionalName: string;
  onClose: () => void;
}

export const RejectCandidateSuccessPopup = ({
  onClose,
  professionalName,
}: IRejectCandidateSuccessPopupProps) => (
  // @ts-expect-error - ConfirmPopup still written in JavaScript
  <ConfirmPopup
    Icon={SuccessIconComponent}
    title="Candidate Status Successfully Updated"
    titleStyle={{ marginTop: 21, marginBottom: 16 }}
    description={
      <Text color={Colors.neutral_500}>
        <Text bold color={Colors.neutral_500}>
          {professionalName}
        </Text>
        ’s application is no longer active and has been
        <br />
        archived under Rejected. Keep reviewing other
        <br />
        applicants to find your next great hire.
      </Text>
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    rightButtonText="Done"
    rightButtonAction={onClose}
  />
);
